import * as React from "react";
import { DataTable, TableHeader, TableRow, TableColumn, 
    TablePagination, FontIcon, MenuButtonColumn , TableBody, SVGIcon, ListItem } from "react-md";
import { isNullOrUndefined } from "util";
import "./static/StyledTable.scss";
import _ = require("lodash");

export interface StyledTableProps {
    headers: string[];
    data: Array<Array<string|undefined>>;
    withActions: boolean;
    actions?: ActionItem[];
    selectable: boolean;
    onItemSelected?: Function;
    clearSelected: Function;
}
export interface ActionItem {
    label: string;
    onClick: Function;
    color?: string;
}
export interface StyledTableState {
    data: Array<Array<string|undefined>>;
    sortKey: Array<{ header: string, sorted: boolean, ascending: boolean }>;   
    slicedData: Array<Array<string|undefined>>;
    start: number;
    rowsPerPage: number;
    currentPage: number;
}
class StyledTable extends React.Component<StyledTableProps, StyledTableState> {
    constructor(props: StyledTableProps ) {
        if (props.withActions) {
            if (isNullOrUndefined(props.actions) || props.actions.length === 0) {
                throw new Error("Action Items are required when withActions is set");
            }
            
        }
        if (props.selectable) {
            if (isNullOrUndefined(props.onItemSelected)) {
                throw new Error("OnItemSelected Callback is requried when selectable is set");
            }
        }
        super(props);
        let data = _.cloneDeep(this.props.data);
        data = data.sort(
            (a , b) => {
                let y = a[0];
                let z = b[0];
                return -1 * ((y || z) ? (!y ? -1 : !z ? 1 : y.localeCompare(z)) : 0);
            }
        );
        this.state = { sortKey: this.props.headers.map(
            item => {return {header: item, sorted: false, ascending: false}; }
        ) ,
        data: data,
        slicedData: data.slice(0, 10),
        start: 0,
        rowsPerPage: 10,
        currentPage: 1
        };
        this.state.sortKey[0].sorted = true;
        this.state.sortKey[0].ascending = false;
        this.sortData = this.sortData.bind(this);
        this.handlePagination = this.handlePagination.bind(this);
        
    }
    getActionsListItems(row: Array<string|undefined>) {
        if (!isNullOrUndefined(this.props.actions)) {
            return this.props.actions.map(
                (action, index) => {
                    if (!isNullOrUndefined(action.color)) {
                        return (
                            <ListItem 
                                        onClick={() => action.onClick(row.slice(0, row.length - 1))}
                                        key={`${row.join("")}${action.label}`} 
                                        primaryText={action.label}
                                        primaryTextStyle={{color: action.color}}
        
                            /> 
                            ); 
                                
                    }
                    return (
                    <ListItem 
                                key={`${row.join("")}${action.label}`} 
                                primaryText={action.label}
                                primaryTextStyle={{color: "#35BCEE"}}
                                onClick={() => action.onClick(row.slice(0, row.length - 1))}

                    /> 
                    ); 
                }  
            );
        }
        return [];
    }
    sortData(index: number) {
        if (this.state.sortKey[index].header !== "Actions") {
            let sortKey = this.state.sortKey;
            let previousSortKeyIndex = sortKey.findIndex(item => item.sorted);
            if (previousSortKeyIndex > -1) {
                sortKey[previousSortKeyIndex].sorted = false;
            }
            sortKey[index].sorted = true;
            sortKey[index].ascending = !sortKey[index].ascending;
            
            let data = this.props.data.sort(
                (a , b) => {
                    let y = a[index];
                    let z = b[index];
                    if (sortKey[index].ascending) {
                        return -1 * ((y || z) ? (!y ? -1 : !z ? 1 : y.localeCompare(z)) : 0);
                    } else {
                        return (y || z) ? (!y ? -1 : !z ? 1 : y.localeCompare(z)) : 0;
                    }
                }
            );
            this.setState({
                sortKey: sortKey,
                data: data,
                slicedData: data.slice(this.state.start, this.state.start + this.state.rowsPerPage)
            });
        }
    }
    handlePagination(start: number, rowsPerPage: number, currentPage: number) {

        this.setState( (prevState) =>  {return {
            slicedData: prevState.data.slice(start, start + rowsPerPage),
            start: start,
            rowsPerPage: rowsPerPage,
            currentPage: currentPage
        };
    });

        this.props.clearSelected();    
    
    }
    
    componentWillReceiveProps(nextProps: StyledTableProps) {
        let items = this.props.data; 
        let diff = _.isEqual(items, nextProps.data);
        if (!diff) {
            if (nextProps.withActions) {
                if (isNullOrUndefined(nextProps.actions) || nextProps.actions.length === 0) {
                    throw new Error("Action Items are required when withActions is set");
                }
                
            }
            if (nextProps.selectable) {
                if (isNullOrUndefined(nextProps.onItemSelected)) {
                    throw new Error("OnItemSelected Callback is requried when selectable is set");
                }
            }
            let data = _.cloneDeep(nextProps.data);
            data = data.sort(
                (a , b) => {
                    let y = a[0];
                    let z = b[0];
                    return -1 * ((y || z) ? (!y ? -1 : !z ? 1 : y.localeCompare(z)) : 0);
                }
            );
            let sortKey = nextProps.headers.map(
                item => {return {header: item, sorted: false, ascending: false}; }
            );
            sortKey[0].sorted = true;
            sortKey[0].ascending = false;
            this.setState({ sortKey: sortKey ,
            data: data,
            slicedData: data.slice(0, 10),
            start: 0,
            rowsPerPage: 10,
            currentPage: 1
            });
            this.props.clearSelected();
            
        }
        this.props = nextProps;
    }
    render() {
        let visibleHeaders = this.props.headers;
        let visibleData = this.state.slicedData;

        if (this.props.withActions) {
            if (visibleHeaders[visibleHeaders.length - 1] !== "Actions") {
                visibleHeaders.push("Actions");
            }
            visibleData.forEach(item => {
                if (item.length !== visibleHeaders.length) {
                item.push("Actions");
                }
            });
        }

        return(
            <DataTable 
                className='dataTable'
                fixedFooter={true}
                fullWidth={true}
                baseId="simple-pagination"
                indeterminate={true}
            >
                <TableHeader
                    style={
                        {
                            backgroundColor: "#2E4558"
                        }
                    }
                >
                    <TableRow
                        onCheckboxClick={() => {
                        let data = this.state.slicedData.map( item => item.slice(0, item.length - 1));
                        return   !isNullOrUndefined(this.props.onItemSelected) ? 
                        this.props.onItemSelected(data) : () => { return; };
                        } 
                        }
                        selectable={this.props.selectable}
                    >
                    {
                        visibleHeaders.map(
                            (item, index) => {
                                let sortState = this.state.sortKey.find( sortItem => sortItem.header === item);
                                let sort = false;
                                let asc = false;
                                if (!isNullOrUndefined(sortState)) {
                                   sort = sortState.sorted;
                                   asc = sortState.ascending;
                                }
                                if (sort) {
                                    return <TableColumn 
                                            style={{color: "white"}}
                                            onClick={() => this.sortData(index)} 
                                            sortIcon={<FontIcon secondary={true}>arrow_upward</FontIcon>}
                                            sorted={asc} 
                                            key={index}
                                    >
                                    {item}
                                    </TableColumn>;
    
                                } else {
                                    return <TableColumn 
                                            style={{color: "white"}}
                                            onClick={() => 
                                            this.sortData(index)} 
                                            key={index}
                                    >
                                    {item}
                                    </TableColumn>;
    
                                }
    
                            } 
                        )
                    }
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {
                        visibleData.map(
                            (row, index) => {
                                
                                    return <TableRow 
                                                selectable={this.props.selectable} 
                                                onCheckboxClick={() => 
                                                    !isNullOrUndefined(this.props.onItemSelected) ? 
                                                    this.props.onItemSelected(
                                                        [this.state.slicedData[index]
                                                        .slice(0, this.state.slicedData[index].length - 1)]) 
                                                    : () => { return; }
                                                }
                                                key={`${row.join("")}${index}`}
                                    >
                                    {
                                        row.map(
                                            (column, colIndex ) => {
                                            if (column === "Actions") {
                                                return <MenuButtonColumn  
                                                            key={`${row.join("")}Actions${colIndex}`}
                                                            icon={true} 
                                                            menuItems={this.getActionsListItems(row)} 
                                                            listClassName="tables__with-menus__kebab-list"
                                                >
                                                        <SVGIcon>
                                                        <path 
                                                            xmlns="http://www.w3.org/2000/svg" 
                                                            // tslint:disable-next-line:max-line-length
                                                            d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                                        />
                                                        </SVGIcon>
                                                </MenuButtonColumn>;
                                            }
                                            return <TableColumn 
                                                key={`${row.join("")}col${column}${colIndex}`} 
                                                adjusted={false}
                                            >
                                                {column}
                                            </TableColumn>;
                                            }
                                        )   
                                    }
                                    </TableRow>;
    
                            }
                        )
                    }
                </TableBody>
                <TablePagination 
                    page={this.state.currentPage}
                    rows={this.state.data.length} 
                    rowsPerPage={this.state.rowsPerPage}
                    rowsPerPageLabel={"Rows Count"} 
                    onPagination={this.handlePagination} 
                />
            </DataTable>
        );
    }
}

export default StyledTable;


// WEBPACK FOOTER //
// ./src/component/StyledTable/StyledTable.tsx